"use client";
import { createContext } from "react";
//#region src/focusable/focusable-context.tsx
const FocusableContext = createContext(true);
//#endregion
export { FocusableContext };

//# sourceMappingURL=focusable-context.js.map